import React from 'react'

export const PostActionsList = ({ optionsList, confirmAndExecAdminAction }) => {
  return (
    <nav className="dropdown-comp post-admin-options__dropdown-menu">
      {optionsList.map(
        ({ url, text, open_in_new_tab: openInNewTab, should_confirm: shouldConfirm }) => {
          const boundAdminActionHandler = adminActionHandler.bind(
            null,
            url,
            text,
            shouldConfirm,
            confirmAndExecAdminAction
          )
          return (
            <a
              key={text}
              href={url}
              rel="nofollow noopener"
              className="admin-dropdown-action dropdown-comp__item"
              target={openInNewTab ? '_blank' : ''}
              onClick={boundAdminActionHandler}
            >
              {text}
            </a>
          )
        }
      )}
    </nav>
  )
}

const adminActionHandler = (url, text, shouldConfirm, actionHandler, e) => {
  if (shouldConfirm) {
    e.preventDefault()
    actionHandler({ url, text })
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_actions/postActionsList.view.js